export default "__VITE_ASSET__b12bc95d__"